import { fg } from '@confluence/feature-gating';
import { expValEquals } from '@confluence/feature-experiments';

export const usePostOfficeHomeBannerEligible = () => {
	// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/post_office_conf_banner_shadow_traffic_in_conf
	if (fg('post_office_conf_banner_shadow_traffic_in_conf')) {
		return {
			isEligible: true,
		};
	}

	// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/post_office_confluence_home_banner_experiment/setup
	return {
		isEligible: expValEquals(
			'post_office_confluence_home_banner_experiment',
			'cohort',
			'variation',
		),
	};
};
